var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/855779e00a2919eecbbfe0d28df64a90.js').default;export default
        Object.assign({}, scope_0 )
    